import { ScheduleItinetantTemplate } from "../../Templates/ScheduleItinetantTemplate";

export const ScheduleItinetant = () => {
  return <ScheduleItinetantTemplate />;
};
